import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface OnboardingActions {
  setIsGenerateButtonVisible: (isGenerateButtonVisible: boolean) => void;
}
interface OnboardingStore {
  isGenerateButtonVisible: boolean;
  actions: OnboardingActions;
}

const useOnboardingStore = create<OnboardingStore>()(
  devtools(set => ({
    isGenerateButtonVisible: false,
    actions: {
      setIsGenerateButtonVisible: (isGenerateButtonVisible: boolean) =>
        set({ isGenerateButtonVisible })
    }
  }))
);

export const useIsGenerateButtonVisible = () =>
  useOnboardingStore(state => state.isGenerateButtonVisible);
export const useOnboardingActions = () => useOnboardingStore(state => state.actions);
